import { connect } from 'react-redux';
import { accessToken as getAccessToken } from '@core/selectors/user';
import { getCurrentSpaceId } from '@core/selectors/space';
import { AulaState } from '@core/types/state';
import { getParticipants } from '@core/api/spaces/participants';
import {
  operations as assignmentOperations,
  selectors as assignmentSelectors,
} from '@app/store/assignments';
import SubmissionsResponsive from './SubmissionsResponsive';

export const mapStateToProps = (state: AulaState, ownProps: any) => {
  const spaceId = getCurrentSpaceId(state);
  const assignmentId = ownProps.params?.assignmentId;
  const assignment = assignmentId
    ? assignmentSelectors.getAssignment(state, assignmentId)
    : undefined;
  const extensions = assignment
    ? [assignment, ...(assignment.extensions || [])]
    : [];
  return {
    accessToken: getAccessToken(state, spaceId),
    assignment,
    assignmentCreationError:
      assignmentSelectors.getAssignmentCreationError(state),
    assignmentUpdateError: assignmentSelectors.getAssignmentUpdateError(state),
    isFetchingAssignments: assignmentSelectors.isFetchingAssignments(state),
    spaceId,
    user: state.user.user,
    extensions: extensions.map((extension: any) => ({
      ...extension,
      studentsCount: extension.parentAssignmentId
        ? extension.students?.length || 0
        : assignmentSelectors.getAssignmentSubmissions(state, extension.id)
            .length,
    })),
  };
};

export const mapDispatchToProps = (dispatch: any) => ({
  createExtension: (params: any) =>
    dispatch(assignmentOperations.createAssignment(params)),
  editExtension: (params: any) =>
    dispatch(assignmentOperations.editAssignment(params)),
  fetchAssignments: dispatch(assignmentOperations.fetchAssignments),
  fetchSubmissions: (params: { accessToken: string; assignmentId: string }) =>
    dispatch(assignmentOperations.fetchSubmissions(params)),
  loadStudents: (spaceId: string) =>
    getParticipants({ spaceId, limit: 2000, role: 'student' }),
  resetExtensionErrors: () => dispatch(assignmentOperations.resetErrorState()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SubmissionsResponsive);
